export const SET_THEME = 'SET_THEME'
export const SET_NEWSLFASH = 'SET_NEWSLFASH'

export const setTheme = (theme: string) => async dispatch => {
  // @ts-ignore
  document.getElementById('body').className = 'theme-' + theme

  dispatch({ type: SET_THEME, theme })
}
